import React from 'react'
import { Paragraph } from '../components/paragraph/Paragraph'

export function Transcription() {
  return (
    <React.Fragment>
      <Paragraph>
        If you have an audio file that needs transcribing, I can provide you with accurate and well-executed transcription with a prompt turnaround. My fast typing speed, listening skills, in-depth knowledge of punctuation rules, comprehensive understanding of grammar and spelling intricacies and passion for quality and clarity make for user-friendly and reliable transcriptions.
      </Paragraph>
      <Paragraph>
        I am always careful to adhere to style guides, and am well-practiced at transcribing challenging audio that includes repetitions, hesitations and interruptions.
      </Paragraph>
      <Paragraph>
        I have experience in transcribing lengthy medical interviews, promotional and instructional videos and conference recordings.
      </Paragraph>
    </React.Fragment>
  )
}
